import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Edit = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M13.8297459,5.8373837 L17.1626163,9.17025413 L7.33287043,19 L4,19 L4,15.6671296 L13.8297459,5.8373837 Z M16.4071657,3.25996389 C16.7537842,2.91334537 17.3137064,2.91334537 17.660325,3.25996389 L17.660325,3.25996389 L19.7400361,5.33967505 C20.0866546,5.68629357 20.0866546,6.2462158 19.7400361,6.59283433 L19.7400361,6.59283433 L18.1135953,8.2192751 L14.7807249,4.88640467 Z" })));
};
export default Edit;
